import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa"; 
import "./Topheader.css"; 

function Topheader() {
  return (
    <>
      <div style={{background:'#a20000'}} className=" text-sm p-1 text-start text-center">
        <p >
          <a style={{ fontSize:'13px',textDecoration:'none',fontWeight:'300'}} href="tel:+919311797248" className="inline-flex items-center text-white mr-4">
            <FaPhoneAlt  style={{marginRight:'5px'}} />
            +91 93117 97248
          </a>
          <span className="mx-2 text-white">|</span>
          <a style={{ color: "#0000" ,display:'inline-block',fontSize:'13px',textDecoration:'none',fontWeight:'300'}} href="mailto:info@gautamsolar.com" className="inline-flex items-center text-white">
            <FaEnvelope style={{marginRight:'5px'}} />
            info@gautamsolar.com
          </a>
        </p>
      </div>
    </>
  );
}

export default Topheader;


